import React from "react";
import Select from "react-select";

const dropdownSelectStyles = (isError) => ({
  control: (base, state) => ({
    ...base,
    "css-1azwzxf-control": {
      border: "1px solid #ced4da",
    },

    borderColor: isError ? "red" : state.isFocused ? "#ccc" : base.borderColor,
    background: "#F6FAFF",

    boxShadow: state.isFocused ? 0 : 0,
    borderRadius: "15px",

    "&:hover": {
      boxShadow: 0,
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    borderRadius: "15px",
    background: "#fff",
    overflow: "hidden",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected && "#eee",
    color: "#000",
    "&:hover": {
      backgroundColor: "#ddd",
      overflow: "hidden",
    },
    overflow: "hidden",
  }),
  valueContainer: (base) => ({
    ...base,
  }),

  indicatorsContainer: () => ({
    color: "#000",
    display: "flex",
    alignItems: "center",
  }),
  dropdownIndicator: () => ({
    color: "#000",

    marginRight: "10px",
    display: "flex",
    alignItems: "center",
  }),
});

export const ReactSelect = ({
  name,
  placeholder,
  options,
  value,
  clearInputsWhenChange,
  getInputChange,
  setFieldValue,
  setValue,
  noOptionsMessage,
  isError,
  clearStatesWhenInputChange,
}) => {
  return (
    <Select
      {...{
        components: { IndicatorSeparator: () => null },
        name,
        placeholder,
        options,
        value,
        isClearable: true,
        menuPlacement: "bottom",
        styles: dropdownSelectStyles(!!isError),
        blurInputOnSelect: true,
        onChange: (e) => {
          if (clearInputsWhenChange) {
            clearInputsWhenChange.forEach((input) =>
              setFieldValue(input.key, input.value)
            );
          }

          if (setValue) {
            setValue(e);
          }

          if (clearStatesWhenInputChange) {
            clearStatesWhenInputChange();
          }

          setFieldValue(name, e);
        },
        noOptionsMessage: () => noOptionsMessage || "Brak opcji do wyboru",
        onInputChange: (e) => getInputChange && getInputChange(e),
      }}
    />
  );
};
